import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { TrnxCommonTs } from 'src/app/shared/common/trnxCommonTs';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';

import { constants } from 'src/app/shared/common/contants';
import { VaultobjectPopupScreenComponent } from '../../vaultobject-popup-screen/vaultobject-popup-screen.component';
import { ReportlinksserviceService } from '../../reportlinks/reportlinksservice.service';
import { VaultObjectgroupService } from '../../vaultobject-popup-screen/vault-objectgroup.service';
import * as _moment from 'moment';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import { MultipleobjectextractionserviceService } from '../../multipleobjectsextraction/multipleobjectextractionservice.service';
const moment =  _moment;
@Component({
    selector: 'app-headers-popup-dialog',
    templateUrl: './headers-popup-dialog.component.html',
    styleUrls: ['./headers-popup-dialog.component.scss'],
    standalone: false
})
export class HeadersPopupDialogComponent implements OnInit {
  selectedRows=[];

 
  validations_form: UntypedFormGroup;
  ObjectGrid:any;
  paramstemp;
  ObjectsData:any=[];
  vaultGroup:any=[]
  columnDefsForObjects;
  datasetGroupData={"description":"", "datasetGroupName":"",datasetsid: []}
  defaultColDef;
  rowSelection;
  allFields: any[];
  selectedFieldsData: any[];
  gridApiForTablesFields;
  selectedObject;
  selectObjectId: any;
  columnDefsForReportingConfiguration: any[];
  tableFields: any[];
  fieldsData: any[];
  tablefields: any;
  gridAPI;
  validation_messages
  // columnDefsForTablesFields;
  ngModelObjectTemporary;
  fieldsDataToRemove: any;
  selectedFieldsDataToPush: any= [];
  temp: any = [];
  selectedTableFields: any;
  rowbindingdata;
  gridColumnApi;
  getdata: any = []
  backgroundColorScreen="";
  buttonColor="";
  columnDefsForSelectedFields: any;
  rowSelectionForTablesFields;
  components: any;
  isCheckboxSelected: boolean= false;
  // columnDefs;
  value
  retrieveObject: any = [];
  setObject:any=[];
  tableName = "";
  listObjectDropDown: any = [];
  ngModelObject = [];
  updateButton = false;
   allocateButtonsBoolean = false;
  backgroundColorButton = "";
  
  recordsStart = 0;
  retrieveNgModelCreation: any = [];
  gridColumnAPI;
  selectedObjects: any = [];
  buttonName:any = "Save";
  buttonNameClose;
  hide = false;
  eyeIcon = true;
  nextButton = true;
  parentUpdate;
  formValidCheckbox: UntypedFormGroup;
  formValid: UntypedFormGroup;
  screenTypeTOrM: any;
  nextSaveTOrM = "";
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  editmode;
  update




  
 



extraction=[{"objectattributesid":"","name": "","datasetobjectattributes":null,"databasename":"","objectid":"","extractionType" :"MultiObjectExtraction"}]
  headers;
 
  show: boolean = false;
 expand:boolean = false;

 isExpand: boolean = true;
 databases:any;
 eachdatabase;

 gridApi;
 lastpage;
 currentpage;
 nextpage;
 nextpageplusone;
 totalpages;
 pageSize
 names:any = [];
 objectsgroupData:any = [];
 namesData:any = [];
 dnsname:any;
 dnsData:any;
 method;
 vaultObject:any;
 selectedAttributes:any;
 selectedVaultObjects:any;

 attributes:any=[];
 pagesize
 rowClassRules
 paginationPageSize
 paginationNumberFormatter
 methodtype = "insert";
 type
 extractName;
 databasename;
 updatedObject:any=[];


 constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialogref: MatDialogRef<HeadersPopupDialogComponent>,private msg: ErrorMessages, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: UntypedFormBuilder, private localStorageSettings: LocalStorageSettingsService, private formFieldsTrimer: FormFieldsTrimer,private linkservice: ReportlinksserviceService,private constants: constants,private extractService:MultipleobjectextractionserviceService) {
   //messages for validations
   this.validation_messages = this.msg.objectattributes;
   //cell rendering in ag-grid
   this.components = {
     buttonRenderer: Actionbutton,
   }
 }
 formValidation() {
   this.validations_form = new UntypedFormGroup({
     name: new UntypedFormControl(this.extractName, [Validators.required, Validators.maxLength(100)]),
     databasename: new UntypedFormControl(this.databasename, [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100)])
   });
 }
 butttonname;
 columnDefs
 ngOnInit() {
  this.headers=this.data;

  this.defaultExtractionName();
   this.formValidation();


   this.butttonname = "Save";

   this.columnDefsForObjects = [
     {
       headerName: "Headers",
       headerTooltip: "Headers",
       tooltipValueGetter: params => "Headers  : " + params.value,
       field: "headername",
       filter: "agTextColumnFilter",
       width: 400,
       headerCheckboxSelectionFilteredOnly: true,
       checkboxSelection: false,
       sort:'asc',
       animateRows: true,
     }
   ];


   this.columnDefsForSelectedFields = [
    {
      headerName: "Selected Headers",
      headerTooltip: "Selected Headers",
      tooltipValueGetter: params => "Selected Headers : " + params.value,
      field: "headername",
      filter: "agTextColumnFilter",
      width: 400,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: false,
      sort:'asc',
      cellStyle: { " padding-left": "5px" }
    }
  ];

   // below object is resizable, sorting and filter for ag-grid
   this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
     sortable: true,
     resizable: true,
     filter: true
   };


   this.rowSelectionForTablesFields='multiple';
   this.rowSelection = 'multiple';

   this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
   this.buttonColor = this.localStorageSettings.getSettings("ColorA");


 
 }



 defaultExtractionName(){
   let currentdateandtime = moment().format("DDMMYYYY_hhmmss")
   console.log(currentdateandtime)
   this.extractName = currentdateandtime
 }






 onGridReady(params){
   this.gridApi = params;
  //  this.extractService.retrieveobjectattributes(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {

  //    this.spinner.start();

  //    console.log(res);

  //    // checking if response is true or not
  //    if (res.error === true) {

  //      this.spinner.stop();

  //      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });

  //      this.gridApi.api.setGridOption('rowData', );

  //    } else {

  //      this.spinner.stop();

  //      this.ObjectsData=res;

  //      this.gridApi.api.setGridOption('rowData', this.ObjectsData);

  //    }

  //  });
  this.gridApi.api.setGridOption('rowData', );
 }

 refresh(){
   this.onGridReady(this.gridApi)
   
 }



 cellClickedObjects(e){
  this.fieldsData = this.ObjectGrid.api.getSelectedRows();

  this.selectedFieldsData = this.fieldsData;

  console.log(this.selectedFieldsData);
  console.log(this.temp.length)
  // if(this.selectedFieldsData.length>10 || this.temp.length>=10){
  //   this.selectedFieldsData=[];
  //   this.snackbar.open("Only 10 Objects allowed","Ok",{duration:5000})
  // }

 }


 onGridReadyForSelectedTableFields(params, tableName) {
  this.selectedTableFields=params
  //this.gridApiForTablesFields = params.api;
  console.log(this.selectedTableFields)
  this.selectedTableFields.api.setGridOption('rowData', []);
  this.selectedTableFields.api.setGridOption('rowData', tableName);
  //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

}


//forward Icon Function decleation
 pushDataToSelectedFieldsGrid() {
  this.fieldsDataToRemove=[];
  
  this.temp = [];
  let uniq = {}
  console.log(this.selectedFieldsData);
  for (let i = 0; i < this.selectedFieldsData.length; i++) {
    // this.selectedFieldsData[i].headername = this.selectedObject.headername;
    this.selectedFieldsDataToPush.push(this.selectedFieldsData[i]);
    this.headers.filter(eachObject=>{
      if(eachObject.headername === this.selectedFieldsData[i].headername){
        console.log("matched")
        this.selectedFieldsData[i].tempindex = this.headers.indexOf(eachObject);
        this.headers.splice(this.selectedFieldsData[i].tempindex,1);
      }
    })
  }

  console.log(this.selectedFieldsDataToPush)
  //duplicates data not allowed
  this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.headername] && (uniq[obj.headername] = true));
  console.log(this.temp)
  this.ObjectGrid.api.setGridOption('rowData', this.headers);
  this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
  //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
}

//backward Icon Function decleation
popDataToSelectedFieldsGrid() {
  this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
  console.log(this.temp)
  this.fieldsDataToRemove.filter(eachremove=>{
    this.headers.splice(eachremove.tempindex, 0,eachremove);
    this.ObjectGrid.api.setGridOption('rowData', this.headers);
    })
  this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
  //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  this.selectedFieldsDataToPush = this.temp.filter(item =>!this.fieldsDataToRemove.includes(item));
  this.fieldsDataToRemove=null


 }

onRowSelectedToRemove(ev) {
  console.log(ev);
  this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
  console.log(this.fieldsDataToRemove);
}


 async onGridReadyForObjects(params,check) {
    this.ObjectGrid=params;

  this.ObjectGrid.api.setGridOption('rowData', this.headers)
 }



   openSaveForm(){
     this.expand=true
     this.show=true
   }



 cellClickedFields(e){
   console.log(e)
 }

 onselection(params){
   console.log(params)
 }



objectcheck(){
  console.log(this.ObjectGrid)
  console.log(this.updatedObject)
  for(let k=0; k<this.updatedObject.length; k++){
    console.log(this.updatedObject[k]);
    this.headers.filter(eachObject=>{
      if(eachObject.headername === this.updatedObject[k].headername){
        console.log("matched");
        this.headers.splice(this.headers.indexOf(eachObject),1);
      }
    })
  }


this.ObjectGrid.api.setGridOption('rowData', this.headers);
this.spinner.stop()
this.attributesmapping();
}

attributesmapping(){
  console.log(this.updatedObject)
  let uniq = {}
  this.temp=[];
  this.selectedFieldsDataToPush = [];
    for (let i = 0; i < this.updatedObject.length; i++) {
      let selectobjects={"headername":""};
      selectobjects.headername = this.updatedObject[i].headername;
     
      this.selectedFieldsDataToPush.push(selectobjects);
    }
  console.log(this.selectedFieldsDataToPush)
  //duplicates data not allowed
  this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.headername] && (uniq[obj.headername] = true));
  this.method="update";
  console.log(this.temp)
  this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
}


  save(){
    

    // Obtain a reference to the ag-Grid API (this assumes you have previously stored it)
    const gridApi = this.selectedTableFields.api;
    
    const allData = [];
  
    // Iterate through all nodes in the grid
    gridApi.forEachNode((node) => {
      const rowData = node.data;
      allData.push(rowData);
    });
  if(allData.length<=0){
    this.dialogref.close(false)
  }
   
else{
  this.dialogref.close(allData);
}
 
    
  
  }




cancel() {
 
  this.selectedRows=[];
  
      this.dialogref.close();
     
    }











}
